import React from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'hooks';

/**
 * Slim call-to-action shown across the dashboard when the logged-in account has
 * no active paid membership. Links to the billing page (all plans). Renders
 * nothing while membership status is still loading or when a membership exists.
 */
const MembershipBanner: React.FC = () => {
  const { token, hasMembership } = useAppSelector(state => state.auth);

  if (!token || hasMembership !== false) return null;

  return (
    <div
      className="d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 py-2 mb-3"
      style={{
        background: '#fffaeb',
        border: '1px solid #fedf89',
        borderRadius: 10,
        color: '#b54708'
      }}
    >
      <span>
        You don&apos;t have an active membership. Upgrade to unlock all features.
      </span>
      <Link
        to="/billing"
        className="btn btn-sm"
        style={{ background: '#111111', color: '#fff', borderRadius: 8, fontWeight: 500 }}
      >
        View plans
      </Link>
    </div>
  );
};

export default MembershipBanner;
